/*
 * to spare ユーザー行動計測（2026-10-02 追加）
 *  - 商品カードのクリック   → GA4 select_item
 *  - スクロール到達         → GA4 scroll_25 / scroll_50 / scroll_75
 *    （ページ下端までの距離の何%まで。下端付近はGA4標準の scroll(90%) を使う）
 * 送信先は Shopify「Google & YouTube」連携のGA4（G-2YTZDG656Z）に固定。
 * 失敗してもサイトの動作には影響しないよう、すべて try/catch で囲んでいる。
 */
(function () {
  'use strict';
  if (window.__tospareTracking) return;
  window.__tospareTracking = true;
  if (window.Shopify && window.Shopify.designMode) return;

  var GA4_ID = 'G-2YTZDG656Z';

  function send(name, params) {
    try {
      if (typeof window.gtag !== 'function') return;
      params = params || {};
      params.send_to = GA4_ID;
      params.transport_type = 'beacon';
      window.gtag('event', name, params);
    } catch (e) {}
  }

  function listInfo() {
    var p = location.pathname.replace(/\/+$/, '') || '/';
    var m;
    if (p === '/') return { id: 'home', name: 'ホーム' };
    m = p.match(/^\/collections\/([^\/]+)/);
    if (m) return { id: 'collection_' + m[1], name: 'collection/' + m[1] };
    if (/^\/products\//.test(p)) return { id: 'product_related', name: '商品ページ内のおすすめ' };
    if (/^\/search/.test(p)) return { id: 'search', name: '検索結果' };
    if (/^\/blogs\//.test(p)) return { id: 'blog', name: 'ブログ' };
    if (/^\/pages\//.test(p)) return { id: 'page_' + (p.split('/')[2] || ''), name: p };
    return { id: 'other', name: p };
  }

  /* ---- 商品カードのクリック ---- */
  function onCardClick(e) {
    try {
      var link = e.target && e.target.closest ? e.target.closest('a[href*="/products/"]') : null;
      if (!link) return;
      var card = link.closest('.product-card-wrapper, .card-wrapper');
      if (!card) return;
      var heading = card.querySelector('.card__heading a') || link;
      var name = (heading.textContent || '').replace(/\s+/g, ' ').trim();
      var idMatch = (heading.id || '').match(/(\d{8,})$/);
      var handleMatch = (link.getAttribute('href') || '').match(/\/products\/([^\/?#]+)/);
      var cards = Array.prototype.slice.call(document.querySelectorAll('.product-card-wrapper'));
      var li = listInfo();
      send('select_item', {
        item_list_id: li.id,
        item_list_name: li.name,
        items: [
          {
            item_id: idMatch ? idMatch[1] : handleMatch ? handleMatch[1] : '',
            item_name: name,
            item_list_id: li.id,
            item_list_name: li.name,
            index: cards.indexOf(card) + 1,
          },
        ],
      });
    } catch (err) {}
  }
  document.addEventListener('click', onCardClick, true);
  document.addEventListener('auxclick', onCardClick, true);

  /* ---- スクロール到達 ---- */
  var marks = [25, 50, 75];
  var fired = {};
  var ticking = false;

  function checkScroll() {
    ticking = false;
    try {
      var doc = document.documentElement;
      var total = Math.max(doc.scrollHeight, document.body ? document.body.scrollHeight : 0) - window.innerHeight;
      if (total < 200) return;
      var pct = ((window.pageYOffset || doc.scrollTop || 0) / total) * 100;
      for (var i = 0; i < marks.length; i++) {
        if (!fired[marks[i]] && pct >= marks[i]) {
          fired[marks[i]] = true;
          send('scroll_' + marks[i], { percent_scrolled: marks[i] });
        }
      }
    } catch (err) {}
  }

  window.addEventListener(
    'scroll',
    function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(checkScroll);
    },
    { passive: true }
  );
})();
